<template>
    <v-select
       :value="selected_stats" 
       v-bind:items="stats"
       item-value="code" 
       item-text="description" 
       :label="label"
       multiple
       prepend-icon="mdi-filter-outline"
       :clearable="selection_clearable"
       @change="updateData">
       <template v-slot:prepend-item> 
            <!-- select all + deselect all -->
            <v-list-item ripple @mousedown.prevent @click="toggle">
                <v-list-item-action>
                    <v-icon :color="selected_stats.length > 0 ? 'indigo darken-4' : ''">{{ icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>Select All</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
        </template>       
        <template v-slot:selection="{ item, index }"> <!-- so the select element will remain single-line and not push the overview down forcing ugly sidebars to show -->
            <v-chip small v-if="index >= 0 && index < visibleChips">
                <span>{{ item.description }}</span>
            </v-chip>
            <span class="grey--text text-caption" v-if="index === visibleChips">(+{{ selected_stats.length - visibleChips }})</span>                                                               
        </template>                
    </v-select>
</template>

<script>
export default {
    props: {
        selected_stats: {
            type: Array,
            default: function() { return []; },
        },
        label: String,
        field: {
            default: 'eventstatuscode',
            required: true,
        },
        selection_clearable:{
            type: Boolean,
            default: false
        }, 
        visibleChips:{
            type: Number,
            default: 2
        }        
    },
    computed:{
        icon: function () {
            if (this.selectAll) return 'mdi-close-box'
            if (this.selectSome) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
        },
        selectAll: function () {
            return this.selected_stats.length === this.stats.length; // stats declared in mixin
        },
        selectSome: function () {
            return this.selected_stats.length > 0 && !this.selectAll;
        }, 
    },
    data() {
        return {
            stats: [],
            selectedstats: [],
        }
    },
    created() {
        this.getEventStats();
    },
    methods: {
        getEventStats() {
            this.$axios
                .post("ares/json/ares/huov/howz/getHwst.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getHwst"
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        this.showDialog('error', 'Error', res.data.error.message);
                    } else {
                        this.stats = res.data.getHwst;
                        this.setInitialStatusSelection();                        
                    }
                })
        },
        updateData(v) {
            console.log('component', v);
            this.$emit('updateData', { "field": this.field, "value": v === null ? '' : v });
            //this.updateHwst()
        },
        fixDropDown(pop_closed=false) {
            if (pop_closed) {
                this.stats = this.stats.filter(element => element.code !== "closed"); // filter out closed status
            }
        },                    
        setInitialStatusSelection(){            
            this.stats.forEach((element) => {
                // if(element.code!=="closed"){ // this one is initially never selected
                //     this.selectedstats.push(element.code);
                // }
                if(element.selected) {
                    this.selectedstats.push(element.code);
                }
            });
            this.updateData(this.selectedstats);
        },        
        toggle() {
            this.$nextTick(() => {
                if (this.selectAll) {
                    this.selectedstats = [];
                } else {
                    this.selectedstats = this.stats.slice(); //
                }
                this.updateData(this.selectedstats);
            })
        },            
    }
}
</script>

<style scoped>

</style>